
export default function useHasValidQuidMonitorToken() {
    return RivalIQ.state.account.get('hasValidQuidMonitorToken');
}
